import styled from 'styled-components';


const Container = styled.div`
    color: #000;
    background: #fff;
    margin-left: 30px;



    @media screen and (max-width: 768px) {
        padding: 0px;
        margin: 0px;
    }
`
const Wrapper = styled.div`
    border: 3px solid #c3c3c3;
    display: grid;
	grid-template-columns: repeat(auto-fit, 320px);
	gap:20px;
	justify-content: center;
	padding-bottom: 50px;
    z-index: 1;
    height: 280px;
    width: 100%;
    max-width: 350px;
    margin-bottom: 10px;
    margin-right: 10px;
    margin-left: auto;
    padding: 0 24px;
    
`
const Row = styled.div`
    display:grid;
    align-items: center;


`
const Column1 = styled.div`
    margin-top: 40px;
    padding: 0 15px;
    grid-area: col1;
    
`
const TextWrapper = styled.div`
    max-width: 540px;
    padding-top: 0;
    padding-bottom: 60px;
    
`
const TopLine = styled.p`
    color: #01bf71;
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    margin-bottom: 2px;
`
const Heading = styled.h1`
    margin-bottom: 14px;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    color: '#000';

    @media screen and (max-width: 786px) {
        font-size: 32px;
    }
`
const Subtitle = styled.p`
    max-width: 440px;
    margin-bottom: 25px;
    font-size: 15px;
    line-height: 18px;
    font-weight: 300;
    color: '#fff';
`
const BtnWrap = styled.div`
    display: flex;
    justify-content: flex-start;
`
const Btn = styled.div`
    margin: 3px;
    border-radius: 50px;
    background: #8a65f0;
    color: #fff;
    font-weight: 300;
    white-space: nowrap;
    padding: 12px 30px;
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;

    &:hover {
        transition: all 0.2s ease-in-out;
        background : #cebfff;
        color: #000
    }

    @media screen and (max-width:786px){
        padding: 10px 20px;
        font-size: 16px;
    }
`



const ProjectLayout = ({id,name,description,href,web,techused}) => {
    return (
        <>
        <Container id={id}>
            <Wrapper>
                <Row>
                    <Column1>
                        <TextWrapper>
                            <TopLine>{techused}</TopLine>
                            <Heading>{name}</Heading>
                            <Subtitle>{description}</Subtitle>
                            <BtnWrap>
                            <a style={{textDecoration: "none",color:"#000"}} href={web} rel="noreferrer" target='_blank'>
                                <Btn>
                                Demo
                                </Btn>
                                </a>
                                <a style={{textDecoration: "none",color:"#000"}} href={href} rel="noreferrer" target='_blank'>
                                <Btn>
                                Github
                                </Btn>
                                </a>
                            </BtnWrap>
                            
                        </TextWrapper>
                    </Column1>
                </Row>
            </Wrapper>
        </Container>
        </>
    )
}

export default ProjectLayout;